import { useRef, useEffect } from "react"
import { useRouter } from "next/router"
import { useState } from "react"

import { useTranslation } from "lib/i18n/translation"
import { BOTTOM_FILTER, CUSTOM_FILTER } from "lib/products"
import { useProducts } from "lib/products"
import Gtm from "lib/gtm"

import { Navigation, List } from "components/films"

const Films = ({movement, director}) => {
	const { c } = useTranslation("common")
	const [sectionsHeight, setSectionsHeight] = useState([])
	const [sectionPositions, setSectionPositions] = useState([])
	const { catalog, fetchCatalog } = useProducts()
	const router = useRouter()
	const url = router ? router.asPath : null

	const navRef = useRef(null)
	const listRef = useRef( null )

	const [currentAlpha, setCurrentAlpha] = useState("#")

	const baseFilters = []
	if (movement) baseFilters.push({key: BOTTOM_FILTER, value: JSON.parse(decodeURIComponent(movement)) })
	if (director) baseFilters.push({key: CUSTOM_FILTER, value: { ...JSON.parse(decodeURIComponent(director)), type: "director" }})

	const goToAlpha = (section, checkScrollPosition = true) => {
		const currentSection = sectionPositions.find( sp => sp.target === section )

		window.scroll(0, currentSection.top)
		setCurrentAlpha( currentSection.target )

		if(!checkScrollPosition) return

		setTimeout(() => {
			if (document.documentElement.scrollTop !== currentSection.top) {
				goToAlpha(section, false)
			}
		}, 200)
	}

	useEffect(() => {
		if (catalog.length == 0) {
			fetchCatalog(baseFilters.length ? baseFilters : null)
		}
	}, [])

	return (
		<>
			<Gtm pageType="Tous les films" pagePath={url} pageTitle={c("all-films")} />
			<section>
				<h1 className="main-title">
					{c("all-films-strong")}
					{ director && <>{" "}{c("of")} <strong>{JSON.parse(decodeURIComponent(director)).name}</strong></> }
				</h1>
				<div id="films-catalog" className="results-container">
					<Navigation
						ref={ navRef }
						setSectionsHeight={setSectionsHeight}
						baseFilters={baseFilters}
						sectionsHeight={sectionsHeight}
						currentAlpha={ currentAlpha }
						goToAlpha={goToAlpha}
					/>
					<List
						navRef={ navRef }
						listRef={ listRef }
						sectionPositions={ sectionPositions }
						setSectionPositions={setSectionPositions}
						setCurrentAlpha={ setCurrentAlpha }
					/>
				</div>
			</section>
		</>
	)
}

Films.getInitialProps = async (ctx) => {
	return {
		movement: ctx.query.movement,
		director: ctx.query.director
	}
}

export default Films
